import { render, staticRenderFns } from "./AssignStudy.vue?vue&type=template&id=659322a4"
import script from "./AssignStudy.vue?vue&type=script&lang=js"
export * from "./AssignStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports